import React, { useEffect, useState } from "react";
import "./RequestCard.css";
import userLayer from "../../images/userLayer.png";
import profile from "../images/profile.png";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Oval } from "react-loader-spinner";
import { toast } from "react-toastify";
import { FaCaretDown, FaCaretRight } from "react-icons/fa";
import ic_chip_division from "../../images/ic_chip_division.svg";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import dayjs from "dayjs";
import {
  ChevronRight, ChevronDown, Users, ClipboardList,
  CheckCircle2, XCircle, Clock, User, AlertCircle,
} from "lucide-react";

// ── Helpers ──────────────────────────────────────────────────────────────────
const statusConfig = {
  PENDING:  { label: "Pending",  bg: "bg-amber-50",   text: "text-amber-700",  border: "border-amber-200",  dot: "bg-amber-500"  },
  APPROVED: { label: "Approved", bg: "bg-emerald-50",  text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500" },
  REJECTED: { label: "Rejected", bg: "bg-red-50",     text: "text-red-700",    border: "border-red-200",    dot: "bg-red-500"    },
};

const StatusBadge = ({ status }) => {
  const cfg = statusConfig[status] || statusConfig.PENDING;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[10px] font-semibold ${cfg.bg} ${cfg.text} ${cfg.border}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
};

const AvatarFallback = ({ name }) => {
  const initials = name
    ? name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()
    : "?";
  return (
    <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-sm font-bold text-white shadow-sm">
      {initials}
    </div>
  );
};

// ── Component ─────────────────────────────────────────────────────────────────
const RequestCard = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;
  if (storedUserDataArray) companyCode = storedUserDataArray[0].cmpcode;

  const [selectedTab, setSelectedTab]         = useState("Leave");
  const [generalTab, setGeneralTab]           = useState("");
  const [leaveApiLaoder, setLeaveApiLoader]   = useState(false);
  const [generalApiLoader, setGeneralApiLoader] = useState(false);
  const navigate = useNavigate();
  const [leavePending, setLeavePending]       = useState(null);
  const [leaveRejected, setLeaveRejected]     = useState(null);
  const [leaveApproved, setLeaveApproved]     = useState(null);
  const [generalReqData, setGeneralReqData]   = useState(null);
  const [approvalNote, setApprovalNote]       = useState("");
  const [approvalLoader, setApprovalLoader]   = useState(false);
  const [popDisplay, setPopDisplay]           = useState(false);
  const [rejectPopDisplay, setRejectPopDisplay] = useState(false);
  const [RejectNote, setRejectNote]           = useState("");
  const [rejectLoader, setRejectLoader]       = useState(false);
  const [empList, setEmpList]                 = useState("");
  const [portNo, setPortNo]                   = useState("");
  const [empId, setEmpID]                     = useState("");
  const [base_url, setBaseUrl]                = useState(`${base_url_from_axios_config}/`);
  const [empDropOpen, setEmpDropOpen]         = useState(false);

  const userDataString = localStorage.getItem("BondTimeLoginUserData");
  const userData = userDataString ? JSON.parse(userDataString) : [];
  const salesmanNames = userData.map((user) => user.salesman_name?.trim());

  // ── All original effects & handlers untouched ────────────────────────────
  useEffect(() => {
    const storedPortData = JSON.parse(localStorage.getItem("BondTimeportNoData")) || [];
    if (storedPortData) setPortNo(storedPortData[0]?.PORTNO);
  }, []);

  const closeApprovalClick = () => { setPopDisplay(false); setApprovalNote(""); };
  const closeRejectClick   = () => { setRejectPopDisplay(false); setRejectNote(""); };

  const submitApproval = async (item) => {
    setApprovalLoader(true);
    try {
      const api = `${base_url}api/PersonalInfoRequestStatusUpdate/${companyCode}/APPROVED/${item.serialCode}/${salesmanNames[0]}/${approvalNote}`;
      const response = await axios.post(api);
      if (response.status === 200) {
        setPopDisplay(false); toast.success("Request Approved");
        setApprovalNote(""); fetchGeneralReqData(); setApprovalLoader(false);
      }
    } catch (error) { console.log("submitApproval", error); toast.error("Error Updating Request"); setApprovalLoader(false); }
  };

  const submitReject = async (item) => {
    setRejectLoader(true);
    try {
      const api = `${base_url}api/PersonalInfoRequestStatusUpdate/${companyCode}/REJECTED/${item.serialCode}/${salesmanNames[0]}/${RejectNote}`;
      const response = await axios.post(api);
      if (response.status === 200) {
        setRejectPopDisplay(false); toast.success("Request Rejected");
        setRejectNote(""); fetchGeneralReqData(); setRejectLoader(true);
      }
    } catch (error) { console.log("submitReject", error); toast.error("Error Updating Request"); setRejectLoader(true); }
  };

  useEffect(() => {
    setLeavePending(null); setLeaveApiLoader(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(`${base_url}api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/-`);
        setLeavePending(response.data); setLeaveApiLoader(false);
      } catch (error) { console.error("Error fetching data:", error.message); setLeaveApiLoader(false); }
    };
    if (base_url) fetchData();
  }, [base_url]);

  useEffect(() => {
    setLeaveRejected(null);
    const fetchData = async () => {
      try {
        const response = await axios.get(`${base_url}api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/-`);
        setLeaveRejected(response.data);
      } catch (error) { console.error("Error fetching data:", error.message); }
    };
    if (base_url) fetchData();
  }, [base_url]);

  useEffect(() => {
    setLeaveApproved(null);
    const fetchData = async () => {
      try {
        const response = await axios.get(`${base_url}api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`);
        setLeaveApproved(response.data);
      } catch (error) { console.error("Error fetching data:", error.message); }
    };
    if (base_url) fetchData();
  }, [base_url]);

  const fetchGeneralReqData = async () => {
    setGeneralApiLoader(true);
    try {
      const response = await axios.get(
        `${base_url}api/PersonalInfoRequestList/${companyCode}/${generalTab}/${empId ? empId : "-"}/-`,
      );
      if (response.status === 200) { setGeneralReqData(response.data); setGeneralApiLoader(false); }
      setGeneralApiLoader(false);
    } catch (error) { console.error("Error fetchGeneralReqData:", error.message); setGeneralApiLoader(false); }
  };

  useEffect(() => { if (generalTab !== "") fetchGeneralReqData(); }, [generalTab, empId]);

  useEffect(() => {
    const fetchEmpListData = async () => {
      try {
        const response = await axios.get(`${base_url}api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`);
        setEmpList(response?.data);
        console.log("fetchEmpListData response:", response?.data); 
      } catch (error) { 
        console.log("fetchEmpListDataErr", error); }
    };
    if (base_url) fetchEmpListData();
  }, [base_url]);

  const getProfilePic = (dataFromImagePath) => {
    if (dataFromImagePath) {
      const filePath = dataFromImagePath.replace(/\\/g, "/");
      const fileName = filePath.split("/").pop();
      return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
    }
    return null;
  };

  const onCardClick = () => navigate("/admin/leaveapproval");

  // ── Leave card component ──────────────────────────────────────────────────
  const LeaveRequestCard = ({ item }) => {
    console.log("Item in request card:",item)
    const [imgErr, setImgErr] = useState(false);
    const picUrl = getProfilePic(item.imagepath);
    return (
      <div
        onClick={onCardClick}
        className="group flex cursor-pointer flex-col gap-2 rounded-xl border border-slate-200 bg-white p-3 shadow-sm transition-all duration-200 hover:border-blue-200 hover:shadow-md hover:-translate-y-0.5"
      >
        {/* Avatar + Name */}
        <div className="flex items-center gap-3">
          {picUrl && !imgErr ? (
            <img
              className="h-10 w-10 flex-shrink-0 rounded-full object-cover ring-2 ring-white shadow-sm"
              src={picUrl}
              alt={item.Name}
              onError={() => setImgErr(true)}
            />
          ) : (
            <AvatarFallback name={item.Name} />
          )}
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold text-slate-800">
              {item.Name || "--"}
            </p>
            <p className="truncate text-xs text-slate-400">
              {item.JobTitle || "--"}
            </p>
          </div>
          <StatusBadge status="PENDING" />
        </div>

        {/* Dates */}
        <div className="flex items-center gap-1.5 rounded-lg bg-slate-50 px-2.5 py-1.5">
          <Clock className="h-3 w-3 flex-shrink-0 text-slate-400" />
          <span className="text-[11px] text-slate-500">
            {item.FromDate ? dayjs(item.FromDate).format("DD MMM YYYY") : "--"}
            <span className="mx-1 text-slate-300">→</span>
            {item.ToDate ? dayjs(item.ToDate).format("DD MMM YYYY") : "--"}
          </span>
        </div>

        {/* Reason */}
        {item.Reason && (
          <p className="line-clamp-2 text-[11px] text-slate-500 leading-relaxed">
            {item.Reason}
          </p>
        )}

        {/* Division */}
        {item.Division && (
          <div className="flex items-center gap-1.5">
            <img src={ic_chip_division} className="h-3 w-3 flex-shrink-0" alt="" />
            <span className="rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-medium text-blue-600">
              {item.Division}
            </span>
          </div>
        )}
      </div>
    );
  };

  // ── General request card ──────────────────────────────────────────────────
  const GeneralRequestCard = ({ item }) => {
    const [imgErr, setImgErr] = useState(false);
    const picUrl = getProfilePic(item.imagepath);
    const fullName = `${item.FistName || ""} ${item.LastName || ""}`.trim() || "--";
    return (
      <div className="flex flex-col gap-2 rounded-xl border border-slate-200 bg-white p-3 shadow-sm transition-all hover:border-blue-200 hover:shadow-md">
        <div className="flex items-center gap-3">
          {picUrl && !imgErr ? (
            <img
              className="h-10 w-10 flex-shrink-0 rounded-full object-cover ring-2 ring-white shadow-sm"
              src={picUrl}
              alt={fullName}
              onError={() => setImgErr(true)}
            />
          ) : (
            <AvatarFallback name={fullName} />
          )}
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold text-slate-800">{fullName}</p>
            <p className="truncate text-xs text-slate-400">{item.JobTitle || "--"}</p>
          </div>
          <StatusBadge status={generalTab} />
        </div>

        <div className="flex items-center gap-1.5 rounded-lg bg-slate-50 px-2.5 py-1.5">
          <Clock className="h-3 w-3 flex-shrink-0 text-slate-400" />
          <span className="text-[11px] text-slate-500">
            {item.FromDate ? new Date(item.FromDate).toLocaleDateString() : "--"}
            <span className="mx-1 text-slate-300">→</span>
            {item.ToDate ? new Date(item.ToDate).toLocaleDateString() : "--"}
          </span>
        </div>

        {item.Reason && (
          <p className="line-clamp-2 text-[11px] text-slate-500 leading-relaxed">{item.Reason}</p>
        )}

        {item.Division && (
          <div className="flex items-center gap-1.5">
            <img src={ic_chip_division} className="h-3 w-3" alt="" />
            <span className="rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-medium text-blue-600">
              {item.Division}
            </span>
          </div>
        )}
      </div>
    );
  };

  // ── Empty state ───────────────────────────────────────────────────────────
  const EmptyState = ({ label = "No requests found" }) => (
    <div className="flex flex-col items-center justify-center py-10 text-center">
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-100">
        <ClipboardList className="h-6 w-6 text-slate-300" />
      </div>
      <p className="text-sm font-medium text-slate-400">{label}</p>
    </div>
  );

  // ── Loader ────────────────────────────────────────────────────────────────
  const Loader = () => (
    <div className="flex items-center justify-center py-10">
      <Oval height="36" width="36" color="#3B82F6" secondaryColor="#EFF6FF" strokeWidth={3} />
    </div>
  );

  return (
    <div className="flex h-full flex-col overflow-hidden rounded-2xl bg-white">

      {/* ── Card Header ──────────────────────────────────────────────────── */}
      <div className="flex-shrink-0 border-b border-slate-100 px-5 pt-5 pb-0">

        {/* Title row */}
        <div className="mb-3 flex items-center justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Approvals</p>
            <h2 className="text-base font-bold text-slate-900 mt-0.5">Pending Requests</h2>
          </div>

          {/* Employee filter — custom dropdown */}
          {/* <div className="relative">
            <button
              onClick={() => setEmpDropOpen((p) => !p)}
              className="flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs font-medium text-slate-600 shadow-sm transition hover:border-slate-300 hover:bg-white"
            >
              <User className="h-3.5 w-3.5 text-slate-400" />
              {empId || "All Employees"}
              <ChevronDown className="h-3.5 w-3.5 text-slate-400" />
            </button>

            {empDropOpen && (
              <div className="absolute right-0 top-full z-50 mt-1.5 max-h-56 w-48 overflow-y-auto rounded-xl border border-slate-200 bg-white py-1 shadow-xl scrollbar-none">
                <button
                  onClick={() => { setEmpID(""); setEmpDropOpen(false); }}
                  className="w-full px-4 py-2 text-left text-xs font-medium text-slate-700 hover:bg-slate-50"
                >
                  All Employees
                </button>
                {empList && empList.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => { setEmpID(item.EmpId); setEmpDropOpen(false); }}
                    className={`w-full px-4 py-2 text-left text-xs transition hover:bg-slate-50 ${
                      empId === item.EmpId ? "font-semibold text-blue-600" : "text-slate-600"
                    }`}
                  >
                    {item.EmpId}
                  </button>
                ))}
              </div>
            )}
          </div> */}
        </div>

        {/* Main tabs: Leave / General */}
        {/* <div className="flex items-center gap-1">
          {["Leave", "General"].map((tab) => (
            <button
              key={tab}
              onClick={() => {
                setSelectedTab(tab);
                if (tab === "General") setGeneralTab("PENDING");
              }}
              className={`rounded-t-xl px-5 py-2.5 text-sm font-semibold transition-all ${
                selectedTab === tab
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-slate-400 hover:text-slate-600"
              }`}
            >
              {tab === "Leave" ? (
                <span className="flex items-center gap-1.5">
                  <ClipboardList className="h-4 w-4" /> Leave
                  {leavePending && leavePending.length > 0 && (
                    <span className="rounded-full bg-amber-500 px-1.5 py-0.5 text-[10px] font-bold text-white leading-none">
                      {leavePending.length}
                    </span>
                  )}
                </span>
              ) : (
                <span className="flex items-center gap-1.5">
                  <Users className="h-4 w-4" /> General
                </span>
              )}
            </button>
          ))}
        </div> */}
      </div>

      {/* ── Sub-tabs ──────────────────────────────────────────────────────── */}
      {/* <div className="flex-shrink-0 border-b border-slate-100 bg-slate-50 px-5 py-2">
        {selectedTab === "Leave" && (
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate("/admin/leavePage")}
              className="flex items-center gap-1.5 rounded-full bg-emerald-50 border border-emerald-200 px-3 py-1 text-xs font-semibold text-emerald-700 transition hover:bg-emerald-100"
            >
              <CheckCircle2 className="h-3.5 w-3.5" />
              Approved
              <span className="ml-0.5 rounded-full bg-emerald-200 px-1.5 py-0.5 text-[10px] font-bold text-emerald-800">
                {leaveApproved ? leaveApproved.length : 0}
              </span>
              <ChevronRight className="h-3 w-3 opacity-60" />
            </button>
            <button
              onClick={() => navigate("/admin/leavePage")}
              className="flex items-center gap-1.5 rounded-full bg-red-50 border border-red-200 px-3 py-1 text-xs font-semibold text-red-600 transition hover:bg-red-100"
            >
              <XCircle className="h-3.5 w-3.5" />
              Rejected
              <span className="ml-0.5 rounded-full bg-red-200 px-1.5 py-0.5 text-[10px] font-bold text-red-800">
                {leaveRejected ? leaveRejected.length : 0}
              </span>
              <ChevronRight className="h-3 w-3 opacity-60" />
            </button>
          </div>
        )}

        {selectedTab === "General" && (
          <div className="flex items-center gap-1.5">
            {[
              { key: "PENDING",  label: "Requested", Icon: Clock          },
              { key: "APPROVED", label: "Approved",  Icon: CheckCircle2   },
              { key: "REJECTED", label: "Rejected",  Icon: XCircle        },
            ].map(({ key, label, Icon }) => (
              <button
                key={key}
                onClick={() => setGeneralTab(key)}
                className={`flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold transition-all ${
                  generalTab === key
                    ? key === "PENDING"
                      ? "border-amber-300 bg-amber-50 text-amber-700"
                      : key === "APPROVED"
                        ? "border-emerald-300 bg-emerald-50 text-emerald-700"
                        : "border-red-300 bg-red-50 text-red-600"
                    : "border-slate-200 bg-white text-slate-500 hover:bg-slate-50"
                }`}
              >
                <Icon className="h-3 w-3" />
                {label}
              </button>
            ))}
          </div>
        )}
      </div> */}

      {/* ── Card Body ─────────────────────────────────────────────────────── */}
      <div className="flex-1 overflow-y-auto p-4 scrollbar-none">

        {/* Leave tab */}
        {selectedTab === "Leave" && leaveApiLaoder && <Loader />}

        {selectedTab === "Leave" && !leaveApiLaoder && leavePending && leavePending.length > 0 && (
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {leavePending.map((item, index) => (
              <LeaveRequestCard key={index} item={item} />
            ))}
          </div>
        )}

        {selectedTab === "Leave" && !leaveApiLaoder && (!leavePending || leavePending.length === 0) && (
          <EmptyState label="No pending leave requests" />
        )}

        {/* General tab */}
        {selectedTab === "General" && generalApiLoader && <Loader />}

        {selectedTab === "General" && !generalApiLoader && generalReqData && generalReqData.length > 0 && (
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {generalReqData.map((item, index) => (
              <GeneralRequestCard key={index} item={item} />
            ))}
          </div>
        )}

        {selectedTab === "General" && !generalApiLoader && (!generalReqData || generalReqData.length === 0) && (
          <EmptyState label={`No ${generalTab?.toLowerCase() || ""} general requests`} />
        )}
      </div>
    </div>
  );
};

export default RequestCard;